/**
 * @license
 * Copyright Santander UK. All Rights Reserved.
 */
import { Injectable } from '@angular/core';
import { constants } from '../../configs/config-internal-constants';

@Injectable()
export class BrandService {
  constructor() {
    this.isRetail();
    this.isSbbi();
    this.isCahoot();
  }

  isSbbi() {
    let isSbbi = false;
    for (const entry of constants.sbbiDomains) {
      if (this.getHost().indexOf(entry) !== -1) {
        isSbbi = true;
      }
    }
    return isSbbi;
  }

  isRetail() {
    let isRetail = false;
    for (const entry of constants.retailDomains) {
      if (this.getHost().indexOf(entry) !== -1) {
        isRetail = true;
      }
    }
    return isRetail;
  }

  isCahoot() {
    let isCahoot = false;
    for (const entry of constants.cahootDomains) {
      if (this.getHost().indexOf(entry) !== -1) {
        isCahoot = true;
      }
    }
    return isCahoot;
  }

  getHost() {
    return window.location.hostname;
  }
}
